<script setup>
import { onMounted, onUnmounted, watch } from 'vue'

import { useAuthStore } from './stores/authStore.js'

import { useSync } from './features/useSync.js'
import { useTheme } from './features/useTheme.js'

const authStore = useAuthStore()
const { onVisible } = useSync()
const { initStyles, loadStyles, viewMode } = useTheme()

onMounted(() => {
  initStyles()
  document.addEventListener('visibilitychange', onVisible)
})

onUnmounted(() => document.removeEventListener('visibilitychange', onVisible))

watch([() => authStore.user, viewMode], ([user, mode]) => {
  loadStyles(user, mode)
})
</script>

<template>
  <router-view />
</template>
